//=============================================================================
// app modules
//=============================================================================

//=============================================================================

/**
 * The Superclass of all scenes within the game.
 *
 * @class Scene_Base
 * @constructor
 * @extends Stage
 */

import Log from "./log";
import Error from "./errorFactory";
import Filters from "./filters/module";
import Features from "./features/module";

const modul = angular
    .module("utilityModule", [Filters, Features])
    .factory("Log", Log)
    .factory("Error", Error);

export default modul.name;
